import AddIcon from "@material-ui/icons/Add";
import _ from "lodash";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import messages from "../../assets/locale/messages";
import Button from "../../components/Button";
import AuthorsDelete from "./AuthorsDelete";
import AuthorsForm from "./AuthorsForm/AuthorsForm";
import AuthorsList from "./AuthorsList/AuthorsList";
import Title_Section from "../../components/Title_Section/Title_Section";

export default function index() {
  const lang = useSelector((state) => state.locale.lang);
  const {
    authors: { title, addTitle }
  } = messages[lang];
  const list = useSelector((state) => state.authors.list);
  const [formMode, setFormMode] = useState({
    mode: "add",
    editId: 0
  });
  const selectedAuthor = _.find(list, ["id", formMode.editId]);
  const [addModalOpen, setFormModalOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    id: 0
  });

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={title} />
        <Button
          text={addTitle}
          icon={<AddIcon className="me-2" />}
          onClick={() => {
            setFormModalOpen(true);
            setFormMode({ mode: "add", editId: 0 });
          }}
        />
      </div>
      <AuthorsList
        setFormModalOpen={setFormModalOpen}
        setFormMode={setFormMode}
        lang={lang}
        setDeleteModal={setDeleteModal}
      />
      <AuthorsForm
        setFormModalOpen={setFormModalOpen}
        isOpen={addModalOpen}
        setIsOpen={setFormModalOpen}
        lang={lang}
        mode={formMode.mode}
        selectedAuthor={selectedAuthor}
      />
      <AuthorsDelete
        setDeleteModal={setDeleteModal}
        isOpen={deleteModal.open}
        id={deleteModal.id}
        lang={lang}
      />
    </>
  );
}
